import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "app-header-container" }
const _hoisted_2 = { class: "app-header-wrapper container" }
const _hoisted_3 = { class: "app-header-left" }
const _hoisted_4 = { class: "app-header-image" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "app-header-items" }
const _hoisted_7 = { class: "app-header-item-text" }
const _hoisted_8 = {
  key: 0,
  class: "app-header-item-icon"
}
const _hoisted_9 = { class: "nav" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-chevron-down mark" }, null, -1)
const _hoisted_11 = { class: "sub-nav" }
const _hoisted_12 = { class: "app-header-right" }

import {computed, onBeforeMount} from "vue";
import {storeToRefs} from "pinia";
import {useDataStore, HeaderMenuModel, useLocalizationStore} from "@/shared";
import {ChangeLanguage} from "@/entities";
import {RunPayLogo} from "@/shared";


export default /*#__PURE__*/_defineComponent({
  __name: 'headerbar',
  setup(__props) {

const {translate} = useLocalizationStore();

const {getHeaderMenu} = storeToRefs(useDataStore());
const {} = useDataStore();

const solutionArray = [
      { id: 1, name: 'saas_products', routerName: 'saas' },
      { id: 2, name: 'terminal_solutions', routerName: 'terminal-solution' },
      { id: 3, name: 'documentation_consulting', routerName: 'documentation-consulting' },
    ];

const getMenu = computed((): Array<HeaderMenuModel> => {
  return getHeaderMenu.value;
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: {name:'home-page'},
            class: "app-header-item"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: _unref(RunPayLogo),
                alt: "RunPayLogo",
                height: "49"
              }, null, 8, _hoisted_5)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getMenu.value, (item, ind) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: ind,
              to: {name:item.RouterName},
              class: "app-header-item"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(translate)(item.Text)), 1),
                (item.IsIcon)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("nav", null, [
                        _createElementVNode("ul", _hoisted_9, [
                          _createElementVNode("li", null, [
                            _hoisted_10,
                            _createElementVNode("ul", _hoisted_11, [
                              _createElementVNode("li", null, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(solutionArray, (solutionItem) => {
                                  return _createVNode(_component_router_link, {
                                    class: "nav-router-link",
                                    key: solutionItem.id,
                                    to: {name:solutionItem.routerName}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(translate)(solutionItem.name)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                }), 64))
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_unref(ChangeLanguage))
      ])
    ])
  ]))
}
}

})